import * as React from "react"
const SvgSlideshow = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2 15.143v-6q0-.825.587-1.413A1.93 1.93 0 0 1 4 7.143q.824 0 1.412.587Q6 8.318 6 9.143v6q0 .825-.588 1.412A1.93 1.93 0 0 1 4 17.143q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 15.143m7 4q-.825 0-1.412-.588A1.93 1.93 0 0 1 7 17.143v-10q0-.825.588-1.413A1.93 1.93 0 0 1 9 5.143h6q.824 0 1.413.587.587.588.587 1.413v10q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm9-4v-6q0-.825.587-1.413A1.93 1.93 0 0 1 20 7.143q.824 0 1.413.587.587.588.587 1.413v6q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588q-.824 0-1.413-.588A1.93 1.93 0 0 1 18 15.143m-9 2h6v-10H9z" />
  </svg>
)
export default SvgSlideshow
